<div class="header">
  <div class="company">
    <span class="name">
      {{ company()?.razaoSocial || "Empresa não cadastrada" }}
      <ng-container *ngIf="company()?.cpfCnpj">
        - CNPJ: {{ company()?.cpfCnpj | formatter: "cpfCnpj" }}
      </ng-container>
    </span>
    <small *ngIf="result() as r">
      Última verificação: {{ r.verificadoEm | date: "dd/MM/yyyy HH:mm" }}
    </small>
  </div>
  <app-button
    type="button"
    backgroundColor="var(--blue-500)"
    [text]="loading() ? 'Verificando...' : 'Verificar pendências'"
    [icon]="loading() ? 'pi-spin pi-spinner' : 'pi-refresh'"
    [disabled]="loading()"
    textAlign="flex-start"
    [fullWidth]="false"
    (click)="verify()"
  ></app-button>
</div>

<div class="summary" *ngIf="result() as r">
  <span class="chip erro" [class.muted]="!r.erros">
    <i class="pi pi-times-circle"></i>
    {{ r.erros }} {{ r.erros === 1 ? "erro" : "erros" }}
  </span>
  <span class="chip aviso" [class.muted]="!r.avisos">
    <i class="pi pi-exclamation-triangle"></i>
    {{ r.avisos }} {{ r.avisos === 1 ? "aviso" : "avisos" }}
  </span>
</div>

<form [formGroup]="filters" class="filters">
  <app-select
    formControlName="grupo"
    label="Tipo de pendência"
    placeholder="Todas"
    [options]="groupOptions"
  ></app-select>
  <app-select
    formControlName="severidade"
    label="Gravidade"
    placeholder="Todas"
    [options]="severityOptions"
  ></app-select>
  <app-button
    *ngIf="hasActiveFilter()"
    type="button"
    backgroundColor="var(--slate-500)"
    text="Limpar filtros"
    icon="pi-filter-slash"
    [fullWidth]="false"
    (click)="clearFilters()"
  ></app-button>
</form>

<div class="error" *ngIf="error() as message">
  <i class="pi pi-exclamation-circle"></i>
  {{ message }}
</div>

<div class="loading-container" *ngIf="loading() && !result()">
  <div class="loading-spinner"></div>
  <p>Verificando a parametrização da empresa...</p>
</div>

<ng-container *ngIf="result() as r">
  <ng-container *ngIf="filtered().length; else empty">
    <p class="hint">
      Clique em uma pendência para abrir a aba onde ela é corrigida.
    </p>
    <div class="issues">
      <button
        type="button"
        class="issue"
        *ngFor="let issue of filtered(); trackBy: trackByIssue"
        [class.erro]="issue.severidade === 'ERRO'"
        [class.aviso]="issue.severidade === 'AVISO'"
        [attr.aria-label]="issue.mensagem"
        (click)="open(issue)"
      >
        <span class="group">
          <span class="title">{{ groupLabels[issue.grupo] }}</span>
          <span class="section">{{ issue.secao }}</span>
        </span>
        <span class="severity">{{ severityLabels[issue.severidade] }}</span>
        <span class="message">{{ issue.mensagem }}</span>
      </button>
    </div>
  </ng-container>

  <ng-template #empty>
    <div class="empty" *ngIf="!loading()">
      <ng-container *ngIf="r.total === 0; else filteredOut">
        <i class="pi pi-check-circle"></i>
        <span
          >Nenhuma pendência encontrada. A parametrização está completa.</span
        >
      </ng-container>
      <ng-template #filteredOut>
        <i class="pi pi-filter"></i>
        <span>Nenhuma pendência para os filtros selecionados.</span>
      </ng-template>
    </div>
  </ng-template>
</ng-container>
